(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  document.querySelector('.navigation-drawer-trigger').addEventListener('click', function() {
    console.log('klik');
  fetch(`/?section_id=navigation-drawer-lazy`)
    .then(response => response.text())
    .then(html => {      
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const sectionEl = doc.getElementById('shopify-section-navigation-drawer-lazy');

      // Injecteren in je container
      document.querySelector('.navigation-drawer-lazy').innerHTML = sectionEl.innerHTML;
    });
});

document.querySelector('.open-mobile-lazy-panel').addEventListener('click', function() {
    console.log('klik');
  fetch(`/?section_id=navigation-drawer-lazy-mobile`)
    .then(response => response.text())
    .then(html => {      
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const sectionEl = doc.getElementById('shopify-section-navigation-drawer-lazy-mobile');

      // Injecteren in je container
      document.querySelector('.navigation-drawer.mobile-version').innerHTML = sectionEl.innerHTML;
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
window.addEventListener("load", (event) => {

  console.log('Page fully loaded');

    const productRecommendations = document.querySelectorAll('.tag-related-products-swiper');
    const productInfo = document.querySelector('.product-info');
    const mainProductHandle = productInfo.dataset.mainProdUrl;

    productRecommendations.forEach(productRecommendation => {
      
      const searchTag = productRecommendation.getAttribute('data-search-tag');
      if(searchTag) {
        
        var searchUrl = "/search/?type=product&q=" + searchTag + "&resources%5Boptions%5D%5Bfields%5D=tag";
        
        fetch(searchUrl)
          .then(response => response.text())
          .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');

            console.log('Fetched search results for tag:', searchTag);

            
            
            // Zoek alle product cards in de HTML
            const productCards = doc.querySelectorAll('product-card');
            const productList = productRecommendation.querySelector('.swiper-wrapper');
            
            if (productList && productCards.length > 0) {
              

              
              // Voeg elke product card toe aan de swiper
              var tagCounter = 0;
              productCards.forEach(card => {
                var productCardSearchTag = card.getAttribute('data-search-family');
                const cardHandle = card.getAttribute('handle');
                const cardTags = card.getAttribute('data-tags').toLowerCase();
                
                
                if(mainProductHandle == cardHandle || cardTags.includes('accessory') ) return;
                if(searchTag == productCardSearchTag){
                  
                  const slide = document.createElement('div');
                  slide.className = 'swiper-slide';
                  slide.appendChild(card.cloneNode(true));
                  productList.appendChild(slide);

                    var relatedHeader = $('.search-related-header');
                    relatedHeader.removeClass('hidden');
                  //}
                }
              });

               const inputs = document.querySelectorAll('.tag-related-products-swiper input[data-domain]');
                //const curDomain = window.location.hostname;
                const curDomain = window.location.href;

                inputs.forEach(input => {
                  input.value = curDomain;
                });

              // Initialize Swiper na het toevoegen van de content
              new Swiper(productRecommendation, {
                slidesPerView: 'auto',
                spaceBetween: 20,
                loop: false,
                scrollbar: {
                  el: '.swiper-scrollbar',
                  draggable: true
                },
                breakpoints: {
                  320: {
                    slidesPerView: 1.5,
                    spaceBetween: 10
                  },
                  700: {
                    slidesPerView: 2,
                    spaceBetween: 30
                  },
                  1000: {
                    slidesPerView: 5,
                    spaceBetween: 40
                  }
                }
              });
            }
          });
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-bundles"] && !Shopify.designMode) return;
  try {
    
    const bundleItem = document.querySelector('.bundle__item:not(.out-of-stock)');
    if (bundleItem) {
      // Alleen eerste item zonder "out-of-stock"
      bundleItem.classList.add('popular');
      const popularLabel = bundleItem.querySelector('.most_popular_label');
      popularLabel.classList.remove('hidden');
    }

    const showMoreBundles = document.querySelector('.product-bundles__show_more_btn');
    const hiddenBundles = document.querySelectorAll('.bundle__item.hidden');
    const bundlesOuter = document.querySelector('.product-bundles__outer');
    if(showMoreBundles){
      showMoreBundles.addEventListener('click', function(){
        hiddenBundles.forEach(function(el) {
          el.classList.toggle("hidden");
        });
        bundlesOuter.classList.toggle('expanded');
        if(bundlesOuter.classList.contains('expanded')){
          this.textContent = window.shopmonkey.showLessBundles; // Verander de tekst van de knop
        }else{
          this.textContent = window.shopmonkey.showMoreBundles; // Verander de tekst van de knop
        }
      });
    }

    const mainProductVariants = document.querySelectorAll('.bundle-main-product-card .variant-option');
    const upsellProductVariants = document.querySelectorAll('.bundle-upsell-product-card .variant-option');

    // Initialize event listeners for both main and upsell product variants
    handleVariantSelection(mainProductVariants, true);
    handleVariantSelection(upsellProductVariants, false);

    const bundleButtons = document.querySelectorAll('[data-bundle-add-to-cart]');
    
    bundleButtons.forEach(button => {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        
        const mainVariantId = parseInt(this.getAttribute('data-main-variant'));
        const upsellVariantId = parseInt(this.getAttribute('data-upsell-variant'));

        const domain = this.getAttribute('data-domain-value');
        //const domainJs = window.location.hostname;
         const domainJs = window.location.href;

        
        // Debug logging
        console.log('Main Variant ID:', mainVariantId);
        console.log('Upsell Variant ID:', upsellVariantId);
        
        let formData = {
          'items': [
            {
              'id': mainVariantId,
              'quantity': 1,
              'properties': {
                '_bookerz-domain': domain,
                '_bookerz-checkout-url': domainJs
              }
            },
            {
              'id': upsellVariantId,
              'quantity': 1,
              'properties': {
                '_bookerz-domain': domain,
                '_bookerz-checkout-url': domainJs
              }
            }
          ]
        };
        
        // Debug logging
        console.log('Form Data:', formData);
        
        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        })
        .then(response => {
          if (!response.ok) {
            // Log de response voor meer details
            response.json().then(errorData => {
              console.log('Error Response:', errorData);
            });
            throw new Error('Network response was not ok');
          }
          return response.json();
        })
        .then(data => {
          console.log('Success:', data);
          button.textContent = 'Added to cart!';

          // Methode 1: CustomEvent
          document.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true,
            composed: true
          }));

          // OF Methode 2: Kleine timeout
          setTimeout(() => {
            document.dispatchEvent(new Event('cart:refresh'));
          }, 100);

          
          if (typeof window.refreshCart === 'function') {
            window.refreshCart();
          }

          // Open de cart drawer
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer && typeof cartDrawer.show === 'function') {
            cartDrawer.show();
          }

          // Dispatch het cart:refresh event om de inhoud bij te werken
          document.dispatchEvent(new Event('cart:refresh'));

          fetch(`${window.Shopify.routes.root}cart.js`)
          .then(response => response.json())
          .then(cartData => {
            const cartCount = document.querySelector('cart-count');
            if (cartCount) {
              cartCount.itemCount = cartData.item_count;
            }
          });

          
          setTimeout(() => {
            button.textContent = 'Add to cart';
            button.classList.remove('loading');

            
          }, 2000);
        })
        .catch((error) => {
          console.error('Error:', error);
          button.textContent = 'Error - Try again';
          button.classList.remove('loading');
        });
      });
    });

  function handleVariantSelection(options, isMainProduct) {
    options.forEach(option => {
      option.addEventListener('click', function() {
        const container = isMainProduct 
          ? this.closest('.bundle-main-product-card')
          : this.closest('.bundle-upsell-product-card');
        
        // Remove active class from all options in this container
        container.querySelectorAll('.variant-option').forEach(opt => {
          opt.classList.remove('active');
        });
        
        // Add active class to clicked option
        this.classList.add('active');
        
        // Get the variant ID
        const newVariantId = this.getAttribute('data-variant-id');
        const addToCartButton = container.closest('.product-bundles__tile').querySelector('[data-bundle-add-to-cart]');
        
        if (addToCartButton) {
          const attributeToUpdate = isMainProduct ? 'data-main-variant' : 'data-upsell-variant';
          addToCartButton.setAttribute(attributeToUpdate, newVariantId);
          console.log(`Updated ${isMainProduct ? 'main' : 'upsell'} variant ID to:`, newVariantId);
        }
      });
    });
  }  
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-upsell-smart"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  initUpsellInfoToggles();
  initUpsellAddToCart();
});

// Initialize info panel toggles
function initUpsellInfoToggles() {
  // Open info panels
  document.querySelectorAll('[data-upsell-info-toggle]').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      const productId = this.getAttribute('data-upsell-info-toggle');
      const panel = document.getElementById('upsell-info-' + productId);
      if (panel) {
        panel.hidden = false;
        panel.setAttribute('aria-hidden', 'false');
      }
    });
  });

  // Close info panels
  document.querySelectorAll('[data-upsell-info-close]').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      const productId = this.getAttribute('data-upsell-info-close');
      const panel = document.getElementById('upsell-info-' + productId);
      if (panel) {
        panel.hidden = true;
        panel.setAttribute('aria-hidden', 'true');
      }
    });
  });
}

// Initialize AJAX add to cart
function initUpsellAddToCart() {
  document.querySelectorAll('.upsell-add-to-cart').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      
      const variantId = this.getAttribute('data-variant-id');
      const productTitle = this.getAttribute('data-product-title');
      
      if (!variantId) return;
      
      // Update button state
      const originalText = this.querySelector('.btn-text').textContent;
      this.classList.add('is-adding');
      this.disabled = true;
      
      // Add to cart via Shopify AJAX API
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      })
      .then(function(response) {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(function(data) {
        // Success - update button
        btn.classList.remove('is-adding');
        btn.classList.add('is-added');
        btn.querySelector('.btn-text').textContent = '✓ Added!';
        
        // Dispatch cart refresh event (for theme drawer)
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
        }));
        
        // Reset button after 2 seconds
        setTimeout(function() {
          btn.classList.remove('is-added');
          btn.disabled = false;
          btn.querySelector('.btn-text').textContent = originalText;
        }, 2000);
      })
      .catch(function(error) {
        console.error('Error adding to cart:', error);
        btn.classList.remove('is-adding');
        btn.disabled = false;
        
        // Show error message
        alert('Sorry, there was an error adding this item to your cart. Please try again.');
      });
    });
  });
}

// Initialize Quick View Modal
function initQuickViewModal() {
  const modal = document.getElementById('upsell-quick-view-modal');
  if (!modal) return;
  
  const loading = modal.querySelector('.upsell-modal__loading');
  const dataContainer = modal.querySelector('.upsell-modal__data');
  
  // Quick view buttons
  document.querySelectorAll('.upsell-quick-view-btn').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      const handle = this.getAttribute('data-product-handle');
      const productId = this.getAttribute('data-product-id');
      
      if (!handle) return;
      
      // Show modal with loading state
      modal.hidden = false;
      loading.hidden = false;
      dataContainer.hidden = true;
      document.body.style.overflow = 'hidden';
      
      // Fetch product data
      fetch('/products/' + handle + '.js')
        .then(function(response) { return response.json(); })
        .then(function(product) {
          renderQuickView(product, dataContainer);
          loading.hidden = true;
          dataContainer.hidden = false;
        })
        .catch(function(error) {
          console.error('Error loading product:', error);
          closeModal();
          alert('Sorry, could not load product details');
        });
    });
  });
  
  // Close modal handlers
  modal.querySelectorAll('[data-modal-close]').forEach(function(el) {
    el.addEventListener('click', closeModal);
  });
  
  // ESC key handler
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && !modal.hidden) {
      closeModal();
    }
  });
  
  function closeModal() {
    modal.hidden = true;
    document.body.style.overflow = '';
    
    // Cleanup all keyboard handlers from previous renders
    const gallery = modal.querySelector('.upsell-modal__gallery');
    if (gallery && gallery.keyboardHandler) {
      document.removeEventListener('keydown', gallery.keyboardHandler);
      gallery.keyboardHandler = null;
    }
  }
  
  function renderQuickView(product, container) {
    // Gallery
    const gallery = container.querySelector('.upsell-modal__gallery');
    const mainImage = gallery.querySelector('.upsell-modal__main-image');
    const thumbnails = gallery.querySelector('.upsell-modal__thumbnails');
    const prevBtn = gallery.querySelector('.upsell-modal__nav-prev');
    const nextBtn = gallery.querySelector('.upsell-modal__nav-next');
    
    let currentImageIndex = 0;
    let zoomLevel = 1;
    let isDragging = false;
    let startX = 0, startY = 0;
    let translateX = 0, translateY = 0;
    
    // Update main image
    function updateMainImage(index) {
      currentImageIndex = index;
      const imgSrc = product.images[index];
      mainImage.innerHTML = '<img src="' + imgSrc + '" alt="' + product.title + '" draggable="false">';
      
      // Reset zoom on image change
      resetZoom();
      
      // Update thumbnails
      thumbnails.querySelectorAll('.upsell-modal__thumbnail').forEach(function(thumb, i) {
        thumb.classList.toggle('active', i === index);
      });
      
      // Update navigation buttons visibility
      if (product.images.length > 1) {
        prevBtn.hidden = false;
        nextBtn.hidden = false;
      }
    }
    
    if (product.featured_image) {
      updateMainImage(0);
    }
    
    // Thumbnails
    if (product.images && product.images.length > 1) {
      thumbnails.innerHTML = product.images.map(function(img, index) {
        return '<div class="upsell-modal__thumbnail ' + (index === 0 ? 'active' : '') + '" data-index="' + index + '">' +
          '<img src="' + img + '" alt="' + product.title + '">' +
          '</div>';
      }).join('');
      
      // Thumbnail click handlers
      thumbnails.querySelectorAll('.upsell-modal__thumbnail').forEach(function(thumb) {
        thumb.addEventListener('click', function() {
          updateMainImage(parseInt(this.getAttribute('data-index')));
        });
      });
      
      // Show navigation buttons
      prevBtn.hidden = false;
      nextBtn.hidden = false;
    } else {
      thumbnails.innerHTML = '';
      prevBtn.hidden = true;
      nextBtn.hidden = true;
    }
    
    // Navigation button handlers
    prevBtn.addEventListener('click', function() {
      const newIndex = currentImageIndex > 0 ? currentImageIndex - 1 : product.images.length - 1;
      updateMainImage(newIndex);
    });
    
    nextBtn.addEventListener('click', function() {
      const newIndex = currentImageIndex < product.images.length - 1 ? currentImageIndex + 1 : 0;
      updateMainImage(newIndex);
    });
    
    // Zoom functionality
    const zoomInBtn = gallery.querySelector('[data-zoom="in"]');
    const zoomOutBtn = gallery.querySelector('[data-zoom="out"]');
    const zoomResetBtn = gallery.querySelector('[data-zoom="reset"]');
    
    function applyZoom() {
      const img = mainImage.querySelector('img');
      if (!img) return;
      
      img.style.transform = 'scale(' + zoomLevel + ') translate(' + translateX + 'px, ' + translateY + 'px)';
      
      if (zoomLevel > 1) {
        mainImage.classList.add('zoomed');
      } else {
        mainImage.classList.remove('zoomed');
      }
    }
    
    function resetZoom() {
      zoomLevel = 1;
      translateX = 0;
      translateY = 0;
      applyZoom();
    }
    
    zoomInBtn.addEventListener('click', function() {
      if (zoomLevel < 3) {
        zoomLevel += 0.5;
        applyZoom();
      }
    });
    
    zoomOutBtn.addEventListener('click', function() {
      if (zoomLevel > 1) {
        zoomLevel -= 0.5;
        if (zoomLevel <= 1) {
          resetZoom();
        } else {
          applyZoom();
        }
      }
    });
    
    zoomResetBtn.addEventListener('click', resetZoom);
    
    // Click to zoom
    mainImage.addEventListener('click', function(e) {
      if (zoomLevel === 1) {
        zoomLevel = 2;
        applyZoom();
      }
    });
    
    // Drag to pan when zoomed
    mainImage.addEventListener('mousedown', function(e) {
      if (zoomLevel > 1) {
        isDragging = true;
        startX = e.clientX - translateX;
        startY = e.clientY - translateY;
        mainImage.style.cursor = 'grabbing';
      }
    });
    
    mainImage.addEventListener('mousemove', function(e) {
      if (isDragging && zoomLevel > 1) {
        e.preventDefault();
        translateX = e.clientX - startX;
        translateY = e.clientY - startY;
        applyZoom();
      }
    });
    
    mainImage.addEventListener('mouseup', function() {
      isDragging = false;
      if (zoomLevel > 1) {
        mainImage.style.cursor = 'grab';
      }
    });
    
    mainImage.addEventListener('mouseleave', function() {
      isDragging = false;
      if (zoomLevel > 1) {
        mainImage.style.cursor = 'grab';
      }
    });
    
    // Touch support for mobile
    let touchStartX = 0, touchStartY = 0;
    mainImage.addEventListener('touchstart', function(e) {
      if (zoomLevel > 1 && e.touches.length === 1) {
        touchStartX = e.touches[0].clientX - translateX;
        touchStartY = e.touches[0].clientY - translateY;
      }
    });
    
    mainImage.addEventListener('touchmove', function(e) {
      if (zoomLevel > 1 && e.touches.length === 1) {
        e.preventDefault();
        translateX = e.touches[0].clientX - touchStartX;
        translateY = e.touches[0].clientY - touchStartY;
        applyZoom();
      }
    });
    
    // Keyboard navigation - store reference for cleanup
    function handleKeyboard(e) {
      if (!modal.hidden && product.images && product.images.length > 1) {
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          prevBtn.click();
        } else if (e.key === 'ArrowRight') {
          e.preventDefault();
          nextBtn.click();
        }
      }
    }
    
    // Store handler reference on gallery element for cleanup
    gallery.keyboardHandler = handleKeyboard;
    document.addEventListener('keydown', handleKeyboard);
    
    // Product details
    container.querySelector('.upsell-modal__title').textContent = product.title;
    
    // Price
    const priceHtml = product.compare_at_price && product.compare_at_price > product.price
      ? '<span class="compare-price">' + formatMoney(product.compare_at_price) + '</span>' +
        '<span class="sale-price">' + formatMoney(product.price) + '</span>'
      : '<span>' + formatMoney(product.price) + '</span>';
    container.querySelector('.upsell-modal__price').innerHTML = priceHtml;
    
    // Description
    container.querySelector('.upsell-modal__description').innerHTML = product.description || '';
    
    // Reviews (check for common review apps)
    const reviewsContainer = container.querySelector('.upsell-modal__reviews');
    if (window.SPR && product.id) {
      // Stamped.io / Shopify Product Reviews
      reviewsContainer.innerHTML = '<div class="spr-badge" data-id="' + product.id + '"></div>';
      if (window.SPR.registerCallbacks) window.SPR.registerCallbacks();
      if (window.SPR.initRatingHandler) window.SPR.initRatingHandler();
      if (window.SPR.initDomEls) window.SPR.initDomEls();
    } else if (window.yotpo) {
      // Yotpo
      reviewsContainer.innerHTML = '<div class="yotpo bottomLine" data-product-id="' + product.id + '"></div>';
      if (window.yotpo.refreshWidgets) window.yotpo.refreshWidgets();
    } else {
      reviewsContainer.innerHTML = '';
    }
    
    // Actions
    const addToCartBtn = container.querySelector('.upsell-modal__add-to-cart');
    const viewFullBtn = container.querySelector('.upsell-modal__view-full');
    
    addToCartBtn.setAttribute('data-variant-id', product.variants[0].id);
    addToCartBtn.setAttribute('data-product-title', product.title);
    
    viewFullBtn.href = '/products/' + product.handle;
    
    // Add to cart from modal
    addToCartBtn.onclick = function() {
      this.disabled = true;
      this.textContent = 'Adding...';
      
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: product.variants[0].id,
          quantity: 1
        })
      })
      .then(function(response) { return response.json(); })
      .then(function(data) {
        addToCartBtn.textContent = '✓ Added!';
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
        }));
        setTimeout(function() {
          closeModal();
        }, 1000);
      })
      .catch(function(error) {
        console.error('Error:', error);
        addToCartBtn.textContent = 'Error - Try Again';
        addToCartBtn.disabled = false;
      });
    };
  }
  
  function formatMoney(cents) {
    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(cents, window.theme && window.theme.moneyFormat || '€{{amount}}');
    }
    return (cents / 100).toFixed(2);
  }
}

// Reinitialize on section reload (for theme editor)
if (window.Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', function() {
    initUpsellInfoToggles();
    initUpsellAddToCart();
    initQuickViewModal();
  });
}

// Initialize all on DOM ready
document.addEventListener('DOMContentLoaded', function() {
  initQuickViewModal();
});

  } catch(e) { console.error(e); }
})();
})();
